var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.visible)?_c('div',{staticClass:"overlay"},[_vm._m(0)]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cube"},[_c('div',{staticClass:"cube_item cube_x"}),_c('div',{staticClass:"cube_item cube_y"}),_c('div',{staticClass:"cube_item cube_y"}),_c('div',{staticClass:"cube_item cube_x"})])
}]

export { render, staticRenderFns }